import { Countries } from './../../../utils/countries-enum';
import { DynamicComponentManifest } from '../../../dynamic-component-loader/dynamic-component-manifest';
import { DynamicArrayGenerator } from '../../../utils/dynamic-array-generator';

export class JapanManifest {
  da: DynamicArrayGenerator;
  constructor() {
    this.da = new DynamicArrayGenerator();
  }
  public getJPNManifest(): DynamicComponentManifest[] {
    const components = [
      {
        'key': 'tax-fee',
        'module': 'GlobalModule'
      },
      {
        'key': 'display-due-date',
        'module': 'JapanModule'
      },
      {
        'key': 'company-names',
        'module': 'JapanModule'
      },
      {
        'key': 'grid-property-id',
        'module': 'JapanModule'
      },
      {
        'key': 'prefix',
        'module': 'JapanModule'
      },
      {
        'key': 'gst-fee-field',
        'module': 'GlobalModule'
      },
      {
        'key': 'contract-type',
        'module': 'JapanModule'
      },
      {
        'key': 'notice-cancellation',
        'module': 'JapanModule'
      },
      {
        'key': 'vendor-name',
        'module': 'JapanModule'
      },
      {
        'key': 'gws-entity-location',
        'module': 'GlobalModule'
      },
      {
        'key': 'billing-information',
        'module': 'GlobalModule'
      },
      {
        'key': 'tax-fee-percent',
        'module': 'GlobalModule'
      },
      {
        'key': 'accounting-date',
        'module': 'JapanModule'
      },
      {
        'key': 'invoice-form',
        'module': 'JapanModule'
      }
    ];
    // tslint:disable-next-line: no-use-before-declare
    return this.da.generateManifest(components, Countries.Japan);
  }
}
